export default __webpack_public_path__ + "static/media/ic_comprar_medicamentos_home_pro.cc2f9238.svg";